import { RangeHorizon, ResampleIntervals } from '@toggle/chart';
import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { OverviewEventFeed } from '~/modules/overview-event-feed/OverviewEventFeed';
import { SimpleChart } from '~/modules/simple-chart/SimpleChart';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';

import styles from './EntityFullViewDrawer.module.scss';

export interface EntityFullViewDrawerProps {
  entity: Entity;
  trackingSource: PosthogTrackingSource;
}

export const EntityFullViewDrawer = ({
  entity,
  trackingSource,
}: EntityFullViewDrawerProps) => {
  const chartSettings = {
    assets: [
      {
        tag: entity?.tag ?? '',
        snake: entity?.default_snake ?? '',
        paneIndex: 0,
      },
    ],
    resample: ResampleIntervals.OneHour,
    horizon: RangeHorizon.OneMonth,
    domain: null,
    hidden: undefined,
    paneSettings: {},
  };

  return (
    <div className={styles.container}>
      <ErrorBoundaryWrapper>
        <SimpleChart
          entity={entity}
          source={trackingSource}
          initialChartSettings={chartSettings}
          showChartTypeSelector={false}
          eventsConfig={{ TMI: true }}
        />
        <OverviewEventFeed
          entityTag={entity.tag}
          period="1M"
          isDrawer
          showViewAllButton
          source={trackingSource}
        />
      </ErrorBoundaryWrapper>
    </div>
  );
};
